




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PropertyViewModel } from "@/shared/models/property";
import { CategoriesEnum } from "@/shared/models/enums.type";

@Component
export default class PropertyTile extends Vue {
  @Prop() property?: PropertyViewModel;
  @Prop() tileTransition?: boolean;

  @Watch("tileTransition")
  tileTransitionChanged(fresh: boolean) {
    if (this.loadingIndicator === true && fresh === false) {
      this.loadingIndicator = false;
    }
  }

  loadingIndicator = false;

  editProperty(propertyId: number) {
    this.loadingIndicator = true;
    this.$emit("edit", propertyId);
  }

  deleteProperty(property: PropertyViewModel) {
    this.$emit("delete", property);
  }

  imageSrc: any = "";

  mounted() {
    if (this.property?.imageUrl) {
      Vue.axios
        .get(this.property.imageUrl + "?width=420&quality=95", {
          responseType: "blob",
        })
        .then((res) => {
          const reader = new FileReader();
          reader.readAsDataURL(res.data);
          reader.onload = () => {
            this.imageSrc = reader.result;
          };
        })
        .catch(() => {
          this.imageSrc = require("@/assets/images/no-image-icon-23488.png");
        });
    } else {
      this.imageSrc = require("@/assets/images/no-image-icon-23485.png");
    }
  }

  togglePublish(value: boolean, property: PropertyViewModel) {
    Vue.axios
      .put("/properties/SetPropertyBookingEnginePublishStatus/" + property.id, {
        id: property.id,
        isAvailableViaBookingEngine: value,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.IsAvailableViaBookingEngineSaveSuccess"),
          timeout: 5000,
        });
      })
      // reset the toggle back to original value in case of errors
      .catch(() => {
        property.isAvailableViaBookingEngine = !value;
      });
  }

  get category() {
    if (this.property) {
      if (this.property.categoryId === CategoriesEnum.Empty) {
        return 0;
      }
      return this.property.categoryId + 1;
    }
    return 0;
  }
}
